import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/villages'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(village) {
    return http.post(`${resource}`, village)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(village, districtUuid) {
    return http.put(`${resource}/${districtUuid}`, village)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
